export default __webpack_public_path__ + "static/media/conocenos_bg.6f89568c.svg";